import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const REVIEWS = [
  {
    quote:
      "We had a great experience with Daniel and team — punctual, communicative, affordable. Would hire again and recommend!",
    name: "Kirk Williams",
    meta: "Local Guide · 24 reviews",
    time: "a month ago",
    testId: "review-card-1",
  },
  {
    quote:
      "Daniel is the man! Has a good team, did a great job and went above and beyond with making sure my windows were spotless.",
    name: "Sam Bonner",
    meta: "Local Guide · 13 reviews",
    time: "2 months ago",
    testId: "review-card-2",
  },
  {
    quote:
      "Amazing job, great price! Dan and his team are very professional and polite. They even took care of our very high windows with ease. Highly recommended!",
    name: "Ann French",
    meta: "Google review",
    time: "3 months ago",
    testId: "review-card-3",
  },
  {
    quote:
      "Did an awesome job cleaning our windows! We have giant windows and they cleaned them top to bottom. Highly recommend!",
    name: "Brianna Goff",
    meta: "9 reviews · 1 photo",
    time: "4 months ago",
    testId: "review-card-4",
  },
  {
    quote:
      "These young men did a great job cleaning my windows and screens inside and out. They were thorough and very concerned about doing the job well and customer satisfaction. I'd use them again and don't hesitate to recommend.",
    name: "Sally Johnson",
    meta: "9 reviews",
    time: "2 months ago",
    testId: "review-card-5",
  },
  {
    quote:
      "Daniel and Cody did great work! I love supporting local, and having the business owner be so young and hard-working was encouraging to see!",
    name: "Addie Bedford",
    meta: "7 reviews",
    time: "3 months ago",
    testId: "review-card-6",
  },
  {
    quote:
      "They did a fantastic job getting all our super high windows sparkling clean, and they were affordable. We will definitely have them back.",
    name: "Samuel Romans",
    meta: "Google review",
    time: "3 months ago",
    testId: "review-card-7",
  },
];

const Stars = () => (
  <div className="flex gap-1" aria-label="5 out of 5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-sky-500 text-sky-500" />
    ))}
  </div>
);

export const Testimonials = () => {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="border-t border-zinc-200 bg-white"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-32 md:px-12 md:py-44">
        <div className="mb-20 flex flex-col gap-6 md:mb-28 md:flex-row md:items-end md:justify-between">
          <Reveal>
            <p className="mb-4 text-xs font-bold uppercase tracking-[0.35em] text-sky-500">
              Real Google Reviews
            </p>
            <h2 className="max-w-xl font-display text-4xl font-black leading-[0.95] tracking-tighter text-zinc-950 sm:text-5xl lg:text-6xl">
              Billings loves a clear view
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="flex items-center gap-4">
              <Stars />
              <span
                data-testid="reviews-rating-badge"
                className="text-sm font-bold text-zinc-950"
              >
                5.0 on Google — every review, five stars
              </span>
            </div>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {REVIEWS.map((review, i) => (
            <motion.figure
              key={review.name}
              data-testid={review.testId}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: (i % 3) * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group relative flex flex-col justify-between gap-10 rounded-md border border-zinc-200 bg-[#FAFAFA] p-8 transition-colors duration-500 hover:border-sky-500/40 md:p-10"
            >
              <div>
                <Quote className="mb-6 h-8 w-8 text-sky-500/40 transition-colors duration-500 group-hover:text-sky-500" />
                <blockquote className="text-base leading-relaxed text-zinc-700">
                  "{review.quote}"
                </blockquote>
              </div>
              <figcaption className="flex items-end justify-between gap-4">
                <div>
                  <p className="font-display text-sm font-bold tracking-tight text-zinc-950">
                    {review.name}
                  </p>
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">
                    {review.meta} · {review.time}
                  </p>
                </div>
                <Stars />
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
